import i18next from 'i18next'
import {OnlinePaymentStatus} from '@/constants'
import {SelectItem} from '@/components/dumb/Select'

export const statusTabs = () => [
    {
        title: i18next.t(`enums:onlinePaymentStatus.${OnlinePaymentStatus.all}`, { defaultValue: OnlinePaymentStatus.all }),
        key: OnlinePaymentStatus.all
    },
    {
        title: i18next.t(`enums:onlinePaymentStatus.${OnlinePaymentStatus.auth}`, { defaultValue: OnlinePaymentStatus.auth }),
        key: OnlinePaymentStatus.auth
    },
    {
        title: i18next.t(`enums:onlinePaymentStatus.${OnlinePaymentStatus.charge}`, { defaultValue: OnlinePaymentStatus.charge }),
        key: OnlinePaymentStatus.charge
    }
]

export const statusSelectOptions: () => SelectItem[] = () => Object.entries(
    i18next.t('enums:onlinePaymentStatus', { defaultValue: {}, returnObjects: true })
)
    .map(([value, label]) => ({
        value,
        label
    }))
    .filter((item) => item.value !== OnlinePaymentStatus.other)
